export default {
  text: 'Customer Service',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Customer_service.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#b64c4c" href="#" target="_blank"><button style="color: #ffffff; background-color: #b64c4c;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    Header: {
      icon: 'Title',
      text: 'Header',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px; margin: 0 auto; padding: 10px; text-align: center; background: transparent; line-height: 1.65; font-size: 100%;"><h1 style="color: #b64c4c; padding: 0; text-align: center; font-weight: bold;"><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">Header</span></h1></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Divider: {
      icon: 'Remove',
      text: 'Divider',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto;padding: 20px 50px;text-align: center;background: transparent;"><hr style="border: 1px solid #b64c4c;"></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background-color: #ffffff;"><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/snippets/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;background-repeat: no-repeat;padding: 50px 0 50px 0;background-position: center;background-size: cover;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;"><h2 style="font-size: 35px; font-weight: 600; font-family: Tahoma, Geneva, sans-serif; word-wrap: break-word; line-height: 1.5; display: inline-block; vertical-align: middle;">YOUR STATEMENT <b style="color: #b64c4c;">HERE</b></h2><p style="margin: 0; color: #ffffff; font-size: 14px; font-weight: 550; font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here. We recommend using a darker image on lighter text or lighter image on darker text.</p></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
  
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <meta class="vastreach-theme" data-vast-theme="customerService"/>
</head>	

<body align="center" style="margin: 0;padding:0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table style="max-width: 600px;margin: 0 auto 30px auto;padding: 0;text-align: center;border-radius: .50rem;border-spacing: 0;">
			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;">
						<tr>
							<td> 				
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 20px 20px 20px 20px;border-spacing: 0;">
									<tr>
										<td class="col" width="290" valign="center" align="left">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
													<img src="https://vastreach.com/static_assets/email/customer_service/beta-logo.png" alt="logo" style="max-width: 300px;margin: 0 auto;display: block;" />
													</td>
												</tr>
											</table>
										</td>
										<td class="col" width="290" valign="center" align="right">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
													<a href="#" target="_blank" style="text-decoration: none;"><h2 style="margin-right: 10px; font-size: 15px; color: #b64c4c;">VISIT SITE</h2></a>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->				
				</td>	
			</tr>		

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td> 				
								<table valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/customer_service/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;border-spacing: 0;margin: 0 auto;width: 100%;background-repeat: no-repeat;">
									<tr>
										<td>
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin: 0 auto 0 auto;border-spacing: 0;">
												<tr>
													<td valign="middle" style="text-align: center; padding: 100px 50px 100px 50px; font-size: 15px; line-height: 20px; color: #ffffff;">
														<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">WE ARE HERE TO <b style="color: #b64c4c;">HELP</b></span></h2>
														<p><strong><span style="font-size: medium;color:#ffffff;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here.</span></strong></p>                      
													</td>
												</tr>	                                   	
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr> 

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		  
						<h1 style="padding: 0;margin: 0;color: #b64c4c;"><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">-CUSTOMER SERVICE-</span></h1>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;">        
						<span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe how you can you can help your reader in a short sentence. Make sure to leave the key features to highlight below in more detail.</span>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>	
			</tr>		

			<tr>
				<td valign="top" class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 50px 10px 50px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">				
						<div style="margin: 0 auto 0 auto;border-spacing: 0;border: 2px solid #b64c4c;">
							<table cellspacing="0" cellpadding="0" border="0" style="border-spacing: 0;margin: 0 auto;">
								<tr>
									<td style="padding: 25px">
										<img src="https://vastreach.com/static_assets/email/customer_service/phone.png" alt="phone" style="width: 50px;max-width: 100%;margin: 0 auto;display: block;">
									</td>
								</tr>                            	
								<tr>
									<td style="padding: 10px;">
										<h2 style="padding-bottom: 20px;text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif;">Mobile Support</span></h2>     
										<span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your features here in short but detailed paragraphs to show your reader what this feature can provide them.</span>								
									</td>
								</tr>                                
							</table>	
						</div>
					<div>							 
					<!-- End of Dynamic WYSIWYG Content -->								
				</td>
			</tr>

			<tr>
				<td valign="top" class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 50px 10px 50px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<div style="margin: 0 auto 0 auto;border-spacing: 0;border: 2px solid #b64c4c;">
							<table cellspacing="0" cellpadding="0" border="0" style="border-spacing: 0;margin: 0 auto;">
								<tr>
									<td style="padding: 25px">
										<img src="https://vastreach.com/static_assets/email/customer_service/fix.png" alt="Troubleshooting" style="width: 50px;max-width: 100%;margin: 0 auto;display: block;">
									</td>
								</tr>                            	
								<tr>
									<td style="padding: 10px;">
										<h2 style="padding-bottom: 20px;text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif;">Troubleshooting</span></h2>
										<span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your features here in short but detailed paragraphs to show your reader what this feature can provide them.</span>
									</td>
								</tr>
							</table>                                
						</div>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->								
				</td>
			</tr>

			<tr>
				<td valign="top" class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 50px 10px 50px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">		
						<div style="margin: 0 auto 0 auto;padding: 0;border-spacing: 0;border: 2px solid #b64c4c;">
							<table cellspacing="0" cellpadding="0" border="0" style="border-spacing: 0;margin: 0 auto;">
								<tr>
									<td style="padding: 25px">
										<img src="https://vastreach.com/static_assets/email/customer_service/cloud.png" alt="cloud" style="width: 50px;max-width: 100%;margin: 0 auto;display: block;">
									</td>
								</tr>                            	
								<tr>
									<td style="padding: 10px;">
										<h2 style="padding-bottom: 20px;text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif;">Cloud Back-Ups</span></h2>
										<span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your features here in short but detailed paragraphs to show your reader what this feature can provide them.</span>
									</td>
								</tr>                                
							</table>
						</div>
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->								
				</td>
			</tr>

			<tr>
				<td valign="top" class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 50px 10px 50px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<div style="margin: 0 auto 0 auto;padding: 0;border-spacing: 0;border: 2px solid #b64c4c;"> 
							<table cellspacing="0" cellpadding="0" border="0" style="border-spacing: 0;margin: 0 auto;">
								<tr>
									<td style="padding: 25px">
										<img src="https://vastreach.com/static_assets/email/customer_service/call.png" alt="phone" style="width: 50px;max-width: 100%;margin: 0 auto;display: block;">
									</td>
								</tr>                            	
								<tr>
									<td style="padding: 10px;">
										<h2 style="padding-bottom: 20px;text-align: center;"><span style="font-family: Arial, Helvetica, sans-serif;">24/7 Support</span></h2>
										<span style="font-size: medium;color:#555555;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your features here in short but detailed paragraphs to show your reader what this feature can provide them.</span>
									</td>
								</tr>                                 
							</table>
						</div>
					</div>							 
					<!-- End of Dynamic WYSIWYG Content -->								
				</td>
			</tr>						

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" >
					<div style="max-width: 600px;margin: 0 auto;padding: 20px 50px;text-align: center;background: transparent;">	
						<hr style="border: 1px solid #b64c4c;">
					</div>							
				</td>
			</tr> 		
						
			<tr>
				<td class="vastreach-sections" data-vast-editor="social-media">
					<!-- Dynamic WYSIWYG Content -->	
					<table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center">
						<tr>
							<td width="600" align="center">
								<table style="margin: 20px 0 20px 0;">
									<tr>
										<td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #b64c4c;padding: 4px; border-radius:28px;" /></a> </td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->				
				</td>	
			</tr>        					
		</table> 	
	</div>		
</div>		
</body>	
</html>`,
}
